import { CircularProgress, Dialog, DialogContent, Flex, Text } from '@shared/components';

export interface RecurringExamEventCreationLoadingModalProps {
  open: boolean;
  totalCount: number;
}

export default function RecurringExamEventCreationLoadingModal(
  props: Readonly<RecurringExamEventCreationLoadingModalProps>,
) {
  const { open, totalCount } = props;
  return (
    <Dialog open={open} sx={{ '& .MuiPaper-root': { width: '378px' } }}>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <CircularProgress />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'center' })}
        >
          <Text variant='h5'>กำลังสร้างรอบสอบ</Text>
          <Text color='secondary'>กรุณารอสักครู่</Text>
          <Text color='secondary'>ระบบกำลังสร้างรอบสอบทั้งหมด {totalCount} รอบ</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
